import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import React from "react";

import styles from "./Mobile.module.scss";

export const Mobile: React.FC = () => {
  return (
    <div id="mobile-app">
      <Grid
        container
        direction="row"
        justifyContent="center"
        alignItems="center"
        spacing={3}
      >
        <Grid item md={7} sm={12} className={styles.desc}>
          <Typography className={styles.coreHeaderDesc}>Shop Smart.</Typography>
          <Typography className={styles.coreHeaderDesc}>
            Compare in Second.
          </Typography>

          <Box className={styles.coreDesc}>
            Get the most of retail market information, all in one place.
            Download our app now!
          </Box>

          <Box className={styles.downloadBox}>
            <Box
              display="inline"
              sx={{cursor: "pointer"}}
              onClick={() =>
                window.open(
                  "https://apps.apple.com/hk/app/checkafy/id1543598748?l=en",
                  "_blank"
                )
              }
            >
              <img src="./app-store-download-button.svg" width="170px" alt="" />
            </Box>
            <Box
              display="inline"
              sx={{cursor: "pointer"}}
              onClick={() =>
                window.open(
                  "https://play.google.com/store/apps/details?id=io.checkafy.android",
                  "_blank"
                )
              }
            >
              <img
                src="./google-play-download-button.svg"
                width="150px"
                alt=""
              />
            </Box>
          </Box>
        </Grid>
        <Grid item md={5} sm={12}>
          <Box className={styles.parent}>
            <Box
              component="img"
              sx={{
                width: {
                  width: "40%",
                },
              }}
              alt=""
              src="/android_download_2.png"
              className={styles.image2}
            />
            <Box
              component="img"
              sx={{
                width: "60%",
              }}
              alt=""
              src="/ios_download_2.png"
              className={styles.image1}
            />
          </Box>
        </Grid>
      </Grid>
    </div>
  );
};
